<template>
	<div class="editor-content-view">
		<Toolbar
			style="border-bottom: 1px solid #ccc"
			:editor="editorRef"
			:defaultConfig="toolbarConfig"
			:mode="mode"
		/>
		<Editor
			:style="style"
			v-model="valueHtml"
			:defaultConfig="editorConfig"
			:mode="mode"
			@onCreated="handleCreated"
		/>
	</div>
</template>

<script setup>
import { onBeforeUnmount, ref, shallowRef, computed, onMounted } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import cfg from '@/config/config.js'
const props = defineProps({
	modelValue: {
		type: String,
		required: true
	},
	toolbarConfig: {
		type: Object,
		default: {
			toolbarKeys: [
				// 菜单 key
				'headerSelect',
				// 分割线
				'|',
				// 菜单 key
				'bold',
				'italic',
				'color',
				'bgColor',
				'fontSize',
				'fontFamily',
				{
					key: 'group-image',
					title: '图片',
					iconSvg:
						'<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
					menuKeys: ['uploadImage']
				},
				'undo',
				'redo',

				'fullScreen' // 全屏
			]
		}
	},
	editorConfig: {
		type: Object,
		default: {
			placeholder: '请输入内容...',
			uploadImagParams:{

			},
			MENU_CONF: {
				uploadImage: {
					// server: cfg.HOST + '/form/upload',
					server: cfg.HOST + '/upload',
					headers:{Authorization:localStorage.getItem(cfg.TOKEN)},
					fieldName: 'file',
					customInsert(res, inserFn) {
						let url = res.data.url
						inserFn(url, '')
					}
				}
			}
		}
	},
	height: {
		type: String,
		default: '500px'
	}
})

const emits = defineEmits(['update:modelValue'])
let valueHtml = computed({
	get() {
		return props.modelValue
	},
	set(value) {
		emits('update:modelValue', value)
	}
})

let style = computed(() => {
	return {
		height: props.height,

		'overflow-y': 'hidden'
	}
})

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 模式
let mode = ref('default')

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
	const editor = editorRef.value
	if (editor == null) return
	editor.destroy()
})

const handleCreated = (editor) => {
	editorRef.value = editor // 记录 editor 实例，重要！
}
</script>

<style lang="scss" scoped>
// .editor-content-view {
// 	border: 1px solid #ccc;
// 	z-index: 999;
// }
// :deep(p) {
// 	display: flex;
// }
</style>
<style></style>
